<script>
import InvoiceListDesktopView from "./InvoiceListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders InvoiceListDesktopView using the parent invoice-list instance as
 * context so template bindings and $refs stay on list.vue (provide/inject).
 */
export default {
  name: "InvoiceListDesktopBridge",
  inject: ["invoiceList"],
  render() {
    const invoiceList = this.invoiceList;
    const viewOptions = InvoiceListDesktopView.options || InvoiceListDesktopView;
    const render = viewOptions.render;

    if (!invoiceList || typeof render !== "function") {
      return null;
    }

    const options = invoiceList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(invoiceList, invoiceList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
